<template>
  <div class="m-file-list">
    <div
      v-for="(file, index, key) in value"
      :key="key"
      class="m-file-list__item">
      <b class="m-file-list__item__file-text">
        {{ file.title || file.name }}
      </b>
      <a
        class="m-file-list__item__remove float-right"
        @click="onRemove(index)">
        <XMarkIcon />
      </a>
    </div>
  </div>
</template>

<script>
import { XMarkIcon } from '@/components/icons/fontIcons';

export default {
  name: 'VFileList',
  introduction: 'Displays a given list of files with remove buttons.',
  components: {
    XMarkIcon,
  },
  methods: {
    onRemove(index) {
      const file = this.value[index];

      this.value.splice(index, 1);

      this.$emit('input', this.value);
      this.$emit('remove', file);
    },
  },
  props: {
    value: {
      type: Array,
      note: 'A list of File objects.',
    },
  },
};
</script>

<style scope>
.m-file-list__item {
  padding: var(--spacing-small);
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  color: #fff;
  border-radius: 30px;
  margin-top: var(--spacing-xs);
}

.m-file-list__item:first-child {
  margin-top: 0;
}

.m-file-list__item__remove {
  position: relative;
  background: var(--color-error);
  border: 1px solid var(--color-error-dark);
  color: #fff;
  line-height: 0;
  height: 20px;
  width: 20px;
  border-radius: 30px;
  margin-left: 5px;
}

.m-file-list__item__remove svg {
  height: 12px;
  width: 12px;
  pointer-events: none;
  position: absolute;
  transform: translate3d(-50%, -50%, 0);
  top: 50%;
  left: 50%;
}
</style>
